import { getData } from './services';

export const getReportedScatteredDays = (query: {
  membershipNumber: string;
  yearOfLeave: string;
  purchaseNumber?: string;
}) =>
  getData(
    `/proxy/api/v1/members/inleave/scattered-days?membershipNo=${
      query.membershipNumber
    }&year=${query.yearOfLeave}${
      query.purchaseNumber ? `&purchaseNo=${query.purchaseNumber}` : ''
    }`
  );
